import React, { type ReactNode } from 'react';

import { AIBorder } from '@atlassian/ai-components';

type AIInputFieldProps = {
	/** The field component to render (e.g. Textfield, TextArea). */
	children: ReactNode;
	/** When true, wraps children in AIBorder with loading state; otherwise renders children only. */
	isLoading: boolean;
};

export const AIInputField: React.FC<AIInputFieldProps> = ({ children, isLoading }) => {
	if (isLoading) {
		return (
			// We use useModalStyles to avoid the glow ring from showing a gap in the corners of the input fields.
			<AIBorder loading hideGlow useModalStyles>
				{children}
			</AIBorder>
		);
	}
	return <>{children}</>;
};
